import {Directive, forwardRef, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';

const PROVIDER_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => AmountValidator),
    multi: true
};

@Directive({
    selector: '[amount]',
    providers: [PROVIDER_VALIDATOR]
})
export class AmountValidator implements Validator {

    @Input('max-amount') maxAmount: number;
    @Input('min-amount') minAmount = 0;

    constructor() {}

    validate(control: AbstractControl) {
        if (control.value || control.value === 0) {
            let value = Number(control.value);

            if (value > this.maxAmount) {
                return {'max-amount': {valid: false}};
            } else if (value < this.minAmount) {
                return {'min-amount': {valid: false}};
            }

            return null;
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/amount.validator.ts